import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import './design/fonts.css';
import './design/tokens.css';
import { App } from './App.js';

const root = document.getElementById('root');
if (!root) throw new Error('No #root element — index.html is wrong.');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
